import { render, staticRenderFns } from "./zhiding.vue?vue&type=template&id=d06f04a6&scoped=true&"
import script from "./zhiding.vue?vue&type=script&lang=js&"
export * from "./zhiding.vue?vue&type=script&lang=js&"
import style0 from "./zhiding.vue?vue&type=style&index=0&id=d06f04a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f04a6",
  null
  
)

export default component.exports